<div class="container wrapper">
  <section class="team-wrapper py-5">
    <h1 class="text-center fw-semibold mb-5  font-40">
      Teams
    </h1>

    <div class="container p-0 mt-5">
      <owl-carousel-o [options]="slideOption" dir="ltr">
        <ng-template carouselSlide *ngFor="let item of items">
          <div class="team">
            <img [src]='item.img' class="img-fluid" alt="">

          </div>
          <div class="text-center">
            <h4 class="fw-bold font-22 color-secondary mt-4">{{item.name}}</h4>
            <p class="font-15 fw-regular color-secondary mb-0">{{item.desi}}</p>
          </div>


        </ng-template>

      </owl-carousel-o>
    </div>
  </section>
</div>
